var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C728A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.5,557V324.2h91.8c17.7,0,32.7,3.4,45.1,10.1c12.4,6.7,21.9,16,28.5,27.8c6.6,11.9,9.8,25.5,9.8,41 c0,15.5-3.3,29.1-10,40.9c-6.7,11.8-16.3,21-28.9,27.6s-27.9,9.9-45.7,9.9h-58.5v-39.4h50.6c9.5,0,17.3-1.6,23.5-4.9 c6.2-3.3,10.8-7.9,13.9-13.8c3.1-5.9,4.6-12.6,4.6-20.3c0-7.7-1.5-14.5-4.6-20.3c-3.1-5.8-7.7-10.3-13.9-13.5 c-6.2-3.2-14.1-4.8-23.6-4.8h-33.2V557H159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.3,557V324.2h49.2v192.2h99.8V557H355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.8,557h-82.5V324.2h83.2c23.4,0,43.6,4.6,60.5,13.9c16.9,9.3,29.9,22.6,39,39.9 c9.1,17.3,13.7,38.1,13.7,62.3c0,24.2-4.6,45.1-13.7,62.5c-9.1,17.4-22.2,30.8-39.2,40.1C651.8,552.3,631.5,557,607.8,557z  M574.5,514.8h31.2c14.5,0,26.8-2.6,36.8-7.8c10-5.2,17.5-13.3,22.5-24.2c5-10.9,7.6-25.1,7.6-42.4c0-17.2-2.5-31.2-7.6-42.2 c-5-10.9-12.5-18.9-22.4-24.1c-9.9-5.2-22.2-7.7-36.7-7.7h-31.4V514.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPldIcon);
export default __webpack_public_path__ + "static/media/pld_icon.8f7cbadad99adfb869f83797af087645.svg";
export { ForwardRef as ReactComponent };